export default "__VITE_ASSET__Cgnwvj50__"